import React, { useState, useEffect } from 'react';
import { APIROOT } from '../../../Helpers/configs';

import {
  r2_unfilteredList,
  r2_CheckCabinet,
} from '../../../Helpers/r2_requests';
import { GetAuth } from '../../../Auth/AuthProvider';

import { filterMethod } from '../../../Helpers/helpers';

import {
  Grid,
  Typography,
  TextField,
  Autocomplete,
  Button,
} from '@mui/material';


import { ticketTypoTitle, ticketTypoInfo } from '../../shared/commonStyle';

const InstallTicketCabinetInfo = (props) => {

  const {listId, cabinetData, serialsDataList, deleteSerial, cabinetTypeList, customerCategory, updateSerialWithCallback} = props;
  const enqNotification = GetAuth().Notification; //Custom Hook - Returns a function which can be used to enque Notifications
  const logout = GetAuth().signOut; //Custom Hook - returns Signout function
  

  const validationError = cabinetData.validationError;

  // const [currentEntry, setCurrentEntry] = useState(cabinetData);
  const currentEntry = cabinetData;
  const setCurrentEntry = (callback) => {
    updateSerialWithCallback(listId, callback);
  };

  const [timer, setTimer] = useState(null);
  // const [validationError,setvalidationError] = useState(null);

  

  const [checkSerial, setCheckSerial] = useState(true);

  const getWarranteePeriod = (cabinetDetails) => {
    let returnData = 0;
    if(cabinetDetails && customerCategory)
    {
      if(typeof cabinetDetails[customerCategory] === 'string')
      {
        returnData = parseInt(cabinetDetails[customerCategory]);
      }
    } 
    return returnData;
  }
  
  const ResetSerialTimer = () => {
    clearTimeout(timer);
    setTimer(setTimeout(() => {
      setCheckSerial(true);
    },1000));
  }

  const doValidation =  async (currentEntryTemp, checkSerialTemp) => {
    

    let tempValidationError = null;
    //valid cabinet,warranty period and serial
    if(currentEntryTemp?.cabId && currentEntryTemp.serialNo.trim() !== "" && currentEntryTemp.warranteePeriod >= 0 && currentEntryTemp.warranteePeriod !== "")
    {
      let continueFlow = true;
      let Found = 0;
      for(let i = 0; i < serialsDataList.length; i++)
      {
        if(serialsDataList[i].serialNo.trim() === currentEntryTemp.serialNo.trim())
        {
          Found++;
        }
      }
      if(Found > 1)
      {
        tempValidationError = "Serial number already set in this ticket";
        continueFlow = false;
      }

      if(continueFlow === true && checkSerialTemp)
      {
        let ServerSideCheck = await r2_CheckCabinetV2({enqNotification, logout,currentEntry: currentEntryTemp});
        tempValidationError = ServerSideCheck.validationResult;
        setCheckSerial(!ServerSideCheck.validationDone);
      }
      else
      {
        if(continueFlow === true && currentEntryTemp.validationError === "Serial number already exists")
        {
          return;
        }
      }
    }
    //Cabinet invalid
    //else if(!currentEntryTemp?.cabId && currentEntryTemp.serialNo.trim() !== "" && currentEntryTemp.warranteePeriod >= 0)
    else if(!currentEntryTemp?.cabId)
    {
      tempValidationError = "Please select an cabinet Type";
    }
    //else if(currentEntryTemp?.cabId && currentEntryTemp.serialNo.trim() === "" && currentEntryTemp.warranteePeriod >= 0)
    else if( currentEntryTemp.serialNo.trim() === "")
    {
      tempValidationError = "Serial number can't be empty";
    }
    //Warranty period invalid
    // else if(currentEntryTemp?.cabId && currentEntryTemp.serialNo.trim() !== "" && currentEntryTemp.warranteePeriod < 0)
    else if(currentEntryTemp.warranteePeriod < 0)
    {
      tempValidationError = "Warranty period can't be negative";
    }
    else if(currentEntryTemp.warranteePeriod.trim() === '')
    {
      tempValidationError = "Warranty period can't be empty";
    }
    

    if(currentEntryTemp.validationError !== tempValidationError)
    {
      setCurrentEntry((entry) => {return {...entry, validationError: tempValidationError}});
    }
    
    
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {doValidation(currentEntry,checkSerial)}, [currentEntry,checkSerial]);
  return (
    <Grid
      container
      xs={12}
      md={12}
      flexDirection='row'
      rowGap={1}
      alignContent='flex-start'
    >
      <Grid
        container
        xs={12}
        md={12}
        flexDirection='row'
        rowGap={1}
        columnGap={1}
        alignContent='flex-start'
      >
        <Grid item xs={12} md={12} height='40px'>
          <Typography
            style={ticketTypoTitle}
            sx={{
              color: 'red',
              display: validationError === null ? 'none' : 'block',
            }}
          >
            {validationError}
          </Typography>
        </Grid>
        <Grid item xs={12} md={1}>
          <Typography style={ticketTypoTitle}>Cabinet Type:</Typography>
        </Grid>
        <Grid item xs={12} md={2.6}>
          <Autocomplete
            sx={{
              width: '100%',
              background: '#ffffff',
              padding: 0,
            }}
            name='cabinetType'
            key={'cabinetType_' + listId}
            id='cabinetType'
            variant='standard'
            size='small'
            value={currentEntry.cabEntry}
            onChange={(event, newValue) => {
              setCurrentEntry((entry) => {
                let returnTemp = {...entry, cabEntry: newValue,cabId : newValue?.id, cabType : newValue?.name, warranteePeriod: getWarranteePeriod(newValue)};
                return returnTemp;
              }
              );
            }}
            disablePortal
            options={cabinetTypeList.rows ?? []}
            filterOptions={filterMethod}
            getOptionLabel={(option) => option.name}
            renderInput={(params) => <TextField {...params} />}
            isOptionEqualToValue={(option, value) => {
              return option.id === value.id ? true : false;
            }}
          />
        </Grid>
        <Grid item xs={12} md={1}>
          <Typography style={ticketTypoTitle}>Serial Number:</Typography>
        </Grid>
        <Grid item xs={12} md={2.2}>
          <TextField
            id={'serialNumber_' + listId}
            fullWidth
            size='small'
            variant='outlined'
            value={currentEntry.serialNo}
            sx={{ background: '#fff' }}
            onChange={(event) => {
              setCurrentEntry((entry) => {
                return {...entry, serialNo : event.target.value.trim()}
              });
              ResetSerialTimer();
            }}
          />
        </Grid>
        <Grid item xs={12} md={1.5}>
          <Typography style={ticketTypoTitle}>Warrantee Period:</Typography>
        </Grid>
        <Grid item xs={12} md={1}>
          <TextField
            id={'warranteePeriod_' + listId}
            type='number'
            fullWidth
            size='small'
            variant='outlined'
            value={currentEntry?.warranteePeriod}
            sx={{ background: '#fff' }}
            onChange={(event) => {
              setCurrentEntry((entry) => {
                return {...entry, warranteePeriod : event.target.value}
              });
            }}
            inputProps={{min: 0}}
            // onBlur={(event) => handleBlurEvents(event)}
          />
        </Grid>
        <Grid item xs={3} md={0.5} paddingLeft='10px'>
          <Button
            fullWidth
            size='small'
            variant='contained'
            color='error'
            onClick={() => {
              deleteSerial(listId);
              enqNotification('Cabinet Removed', 'warning');
            }}
          >
            Delete
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default InstallTicketCabinetInfo;

const r2_CheckCabinetV2 = async (config) => {
  const {
    enqNotification, //Function to enque notification
    logout, //Function to log user out in case of expired JWT
    currentEntry,
  } = config;
  let payload = {
    pagereq: {
      filter: {
        fullfilter: [
          {
            field: 'serial_number',
            search: currentEntry.serialNo.trim(),
            strict: true,
          },
        ],
      },
    },
  };
  let JWT = localStorage.getItem('JWT_Key');
  //Set default Headers
  let headers = {
    'content-type': 'application/JSON',
  };
  //Set JWT in header if available
  if (JWT) {
    headers['x-api-key'] = JWT;
  }
  const request = new Request(`${APIROOT}/api/serialnumbers`, {
    method: 'post',
    headers: headers,
    body: JSON.stringify(payload),
  });

  let returnThis = {
    validationDone: true,
    validationResult: null
  };

  await fetch(request)
    .then((data) => {
      if (data.status === 200) {
        return data.text();
      } else {
        throw new Error(`Invalid Response`);
      }
    })
    .then((data) => {
      var parsed = JSON.parse(data);

      if (parsed.success === true) {
        
        if(parseInt(parsed.data.totalrows) !== 0)
        {
          returnThis.validationResult = "Serial number already exists"
        }
      } 
      else {
        if (parsed.message === 'Please login') {
          logout(() => {
            enqNotification('Session Expired', 'warning');
          });
        } 
        else {
          enqNotification(parsed.message, 'error');
        }
      }
    })
    .catch((error) => {
      returnThis.validationDone = false;
      console.log(`Error in request`,error);
      enqNotification(
        typeof error == 'string' ? error : 'Connection Failed',
        'error'
      );
    });
   return returnThis;
}

